export default "/_next/static/819a6971ad295a67e5c36a78064816c2.png";